module.exports = __webpack_public_path__ + "img/aaron-griffin-untitled.7fdf9c1.jpg";